import React, { useContext, useEffect, useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import { EditorContext } from "../../../containers/editor/EditorLayout";
import global from "../../../scss/dhp.scss";
import AssetName from "./Common/AssetName";
import MergeFieldSelectorModal, {
  MergeFieldInfoModal,
  MergeFieldBulkUpdateModal,
  MissingMergeFieldModal,
} from "../Modals/MergeFieldModals";

let style = Object.assign({}, global);

const MergeField = props => {
  const {
    isDocumentReady,
    showMfBulkUpdateModal,
    showMergeFieldSelectorModal,
    showMergeFieldInfoModal,
    showMissingMergeFieldModal,
    setShowMergeFieldInfoModal,
    setShowMissingMergeFieldModal,
    setShowMergeFieldSelectorModal,
  } = useContext(EditorContext);

  const assetName =
    showMissingMergeFieldModal && !showMergeFieldSelectorModal && !showMergeFieldInfoModal
      ? "Missing Merge Fields"
      : props.assetName;

  const [defaultTabIndex, setDefaultTabIndex] = useState(0);

  useEffect(() => {
    if (showMergeFieldSelectorModal) {
      setShowMergeFieldInfoModal(false);
      setShowMissingMergeFieldModal(false);
    }
  }, [showMergeFieldSelectorModal]);

  useEffect(() => {
    if (showMergeFieldInfoModal) {
      setShowMissingMergeFieldModal(false);
      setShowMergeFieldSelectorModal(false);
    }
  }, [showMergeFieldInfoModal]);

  useEffect(() => {
    if (showMissingMergeFieldModal) {
      setShowMergeFieldInfoModal(false);
      setShowMergeFieldSelectorModal(false);
    }
  }, [showMissingMergeFieldModal]);

  useEffect(() => {
    if (showMfBulkUpdateModal && !showMissingMergeFieldModal) {
      setShowMissingMergeFieldModal(true);
      setDefaultTabIndex(1);
    }
  }, [showMfBulkUpdateModal]);

  return (
    <>
      {process.env.IS_MERGE_FIELD_ENABLED && isDocumentReady && (
        <div className={cx("merge-field-asset-pane", style["editor-asset-inner"], style["widgetanimation-asset"])}>
          <AssetName handleWidgetAction={props.handleWidgetAction} assetName={assetName} />
          <div className={style["pr-20"]}>
            {
              /* Display cmf bulk update modal on load from template to document creation (if ref=library) and from missing mf bulk update action for cmf tab  */
              showMfBulkUpdateModal && <MergeFieldBulkUpdateModal />
            }
            {showMergeFieldSelectorModal && !showMergeFieldInfoModal && !showMissingMergeFieldModal && (
              <MergeFieldSelectorModal {...{ defaultTabIndex }} />
            )}
            {showMergeFieldInfoModal && !showMergeFieldSelectorModal && !showMissingMergeFieldModal && (
              <MergeFieldInfoModal />
            )}
            {showMissingMergeFieldModal && !showMergeFieldSelectorModal && !showMergeFieldInfoModal && (
              <MissingMergeFieldModal {...{ defaultTabIndex }} />
            )}
          </div>
        </div>
      )}
    </>
  );
};

MergeField.propTypes = {
  handleWidgetAction: PropTypes.func.isRequired,
  assetName: PropTypes.string.isRequired,
  assetType: PropTypes.string.isRequired,
  assetSchemeType: PropTypes.string,
};

export default MergeField;
